import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Download from "./components/Download";
import Features from "./components/Features";
import Dashboard from "./components/Dashboard";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Workflow from "./components/Workflow";
import PrivacyPolicy from "./components/PrivacyPolicy";
import { LanguageProvider } from "./i18n/LanguageContext";
import "./styles.css";

function App() {
  return (
    <LanguageProvider>
      <Router>
        <div className="App">
          <Header />

          <Routes>
            <Route
              path="/"
              element={
                <>
                  <Hero />
                  <Features />
                  <Workflow />
                  <Dashboard />
                  <Download />
                </>
              }
            />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          </Routes>
        </div>
      </Router>
    </LanguageProvider>
  );
}

export default App;
